import { useMutation } from '@tanstack/react-query';
import { AxiosMutationOptions } from 'api/types';
import { InsuranceFormState } from 'pages/AgentRemoteSale/components/InsuranceBox/types';

import { chooseInsurance } from './insurancesApi';

export function useInsuranceMutate(options?: AxiosMutationOptions<InsuranceFormState, Partial<InsuranceFormState>>) {
  return useMutation((insurance: InsuranceFormState) => chooseInsurance(insurance.id), options);
}
